// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import ClientSearchModalNew from '../ClientSearchModalNew';

const ClientCentralSearch = ({ handleClose, onClientSelect, customOnCreateNewProfileHandler, customSearch }) => (
  <ClientSearchModalNew
    goBack={handleClose}
    selectClient={onClientSelect}
    customClientClickAction={onClientSelect}
    customOnCreateNewProfileHandler={customOnCreateNewProfileHandler}
    renderSelectedItemsHeaderActions={false}
    withAddClientButton
    withTabs
    customSearch={customSearch}
  />
);

ClientCentralSearch.propTypes = {
  onClientSelect: PropTypes.func,
  handleClose: PropTypes.func,
  customOnCreateNewProfileHandler: PropTypes.func,
  customSearch: PropTypes.shape({}),
};

ClientCentralSearch.defaultProps = {
  onClientSelect: () => {},
  handleClose: () => {},
  customOnCreateNewProfileHandler: () => {},
  customSearch: {},
};

export default ClientCentralSearch;
